export default {
  namespaced: true,
  state: () => ({
    itemsRaw: [],
    editingItem: null,
  }),
  getters: {
    itemsHydrated(state, getters, rootState) {
      const projectId = rootState.project.project?.id;
      const authorSort = rootState.project.project?.authorStageSort;
      const userSort = rootState.auth.user?.customSettings?.stageSort?.[projectId];
      const sort = userSort ?? authorSort ?? {};

      return [...state.itemsRaw]
        .sort((a, b) => {
          if (!a.id) {
            return -1;
          }

          return (sort[a.id] ?? 0) - (sort[b.id] ?? 0) || b.id - a.id;
        });
    },
  },
  mutations: {
    setItems(state, payload) { state.itemsRaw = payload; },
    setEditingItem(state, payload) { state.editingItem = payload; },
  },
  actions: {},
};
